<div class="create-venues">
  <div class="p-15">
    <p *ngIf="mode === 'create'">Crear configuración</p>
    <p *ngIf="mode === 'edit'">Editar configuración</p>
  </div>
  <div class="p-15 type-container d-flex align-items-center">
    <div>
      <span>Tipo</span>
      <div class="selector-div">
        <select name="selector" id="selector" (change)="onSelectType($event)">
          <option [selected]="venueTab.type === 'icon'" [ngValue]="'icon'">Icono</option>
          <option [selected]="venueTab.type === 'text'" [ngValue]="'text'">Texto</option>
        </select>
      </div>
    </div>
  </div>
  <div class="p-15">
    <span>Venue Id</span>
    <input class="custom-input" type="text" [(ngModel)]="venueTab.venueId" [readOnly]="isDefaultTab"
      [disabled]="isDefaultTab" />
  </div>
  <div class="p-15">
    <span>Map Id</span>
    <input class="custom-input" type="text" [(ngModel)]="venueTab.mapId" [readOnly]="isDefaultTab"
      [disabled]="isDefaultTab" />
  </div>
  <div class="p-15">
    <span>Minimap Id</span>
    <input class="custom-input" type="text" [(ngModel)]="venueTab.minimapId" [readOnly]="isDefaultTab"
      [disabled]="isDefaultTab" />
  </div>
  <div *ngIf="venueTab.type === 'icon'" class="p-15">
    <span>Icono</span>
    <div class="file-content" *ngIf="!venueTab.file && !imgPreview; else fileExisting"
      (fileDrop)="onFileDropped($event)" fileDropZone>
      <p class="text-drag-file">Arrastra los archivos aquí</p>
      <p class="text-drag-file">— o —</p>
      <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
      <button class="upload-file-btn" (click)="fileUpload.click()">Seleccionar imagen de tu ordenador</button>
    </div>
    <ng-template #fileExisting>
      <div class="file-content">
        <div class="file-box">
          <img *ngIf="imgPreview" [src]="imgPreview" alt="img preview" />
          <span class="previewname" *ngIf="venueTab.file">{{ venueTab.file.name }}</span>
          <button class="element-action-btn" (click)="deleteDroppedFile()">
            <img id="delete" alt="" />
          </button>
        </div>
      </div>
    </ng-template>
  </div>
  <div *ngIf="venueTab.type === 'text'" class="p-15">
    <span>Nombre</span>
    <input class="custom-input" type="text" [(ngModel)]="venueTab.name" />
  </div>
</div>